import { Outlet } from 'react-router-dom';
import { Toaster } from '../ui/sonner';

export const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="public-layout">
      {/* Header */}
      <header className="w-full py-4 px-6 flex justify-center border-b border-border/30">
        <img 
          src="https://customer-assets.emergentagent.com/job_skincare-platform-1/artifacts/48p1gbwz_The-Skin-Nurse-Northampton.png"
          alt="The Skin Nurse"
          className="h-10 object-contain"
          data-testid="public-logo"
        />
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-muted-foreground border-t border-border/30">
        <p>&copy; {new Date().getFullYear()} The Skin Nurse Northampton. All rights reserved.</p>
      </footer>
      
      <Toaster position="top-center" />
    </div>
  );
};
